module.exports = __webpack_public_path__ + "img/這天寫過了.e66ebcd8.svg";